import React, { useEffect } from 'react';
import { Box, Drawer } from '@mui/material';
import { bool, func, number } from 'prop-types';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import * as R from 'ramda';

// Components
import Filters from './FiltersConnector';

const MobileFilters = ({
  customerAuthorizationId,
  isViewDrawerOpen,
  mobileFilterDrawerOpen,
  setMobileFilterDrawerOpen,
}) => {
  useEffect(() => {
    return () => setMobileFilterDrawerOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Drawer
      anchor="right"
      onClose={() => setMobileFilterDrawerOpen(false)}
      open={mobileFilterDrawerOpen && !isViewDrawerOpen && R.isNil(customerAuthorizationId)}
      slotProps={{
        paper: {
          sx: {
            borderBottomLeftRadius: 5,
            borderTopLeftRadius: 5,
            width: 'calc(100% - 32px)',
          },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: 'surface.white',
          boxShadow: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          pr: 1,
          py: 2,
          top: 0,
          zIndex: 2,
        }}
      >
        <ClearRoundedIcon
          onClick={() => setMobileFilterDrawerOpen(false)}
          sx={{ color: 'graphic.icons' }}
        />
      </Box>
      <Filters />
    </Drawer>
  );
};

MobileFilters.propTypes = {
  customerAuthorizationId: number,
  isViewDrawerOpen: bool.isRequired,
  mobileFilterDrawerOpen: bool.isRequired,
  setMobileFilterDrawerOpen: func.isRequired,
};

MobileFilters.defaultProps = {
  customerAuthorizationId: undefined,
};

export default MobileFilters;
